export class HasDataValueConverter {
	toView(array: any): boolean {

		if (array instanceof Array) {
			return array !== undefined && array !== null && array.length > 0;
		}
		return false;
	}
}